export const downloadFile = async (data: Blob, filename: string = 'download') => {
    if (!(data instanceof Blob)) {
        console.log('Not an instance of Blob');
        return;
    }

    const blob = new Blob([data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${filename}-${new Date().toISOString().split('T')[0]}.pdf`;
    link.click();
    window.URL.revokeObjectURL(link.href);
};

export const openFileInNewTab = async (data: Blob, filename: string = 'download') => {
    if (!(data instanceof Blob)) {
        console.log('Not an instance of Blob');
        return;
    }

    const blob = new Blob([data], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(blob);
    const w = window.open(fileUrl, '_blank');
    w && w.focus();
};
